import { AxiosPromise } from "axios";
import { authorizedFetch } from "../../config/auth_axios";
import { ApiUrl } from "../../config/api";
import { GlobalSearchResponse, GlobalSearchOptions } from "./types";

/**
 * Global search across patients, users, and organizations
 * Supports pagination and type filtering
 */
export function globalSearch(
  options?: GlobalSearchOptions
): AxiosPromise<GlobalSearchResponse> {
  const params = new URLSearchParams();
  if (options) {
    if (options.q) params.append("q", options.q);
    if (options.type) params.append("type", options.type);
    if (options.page) params.append("page", options.page.toString());
    if (options.perPage) params.append("per_page", options.perPage.toString());
  }

  return authorizedFetch.get(ApiUrl(`search?${params.toString()}`));
}
